import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'flag-2-off', 'Flag2Off', [["path",{"d":"M5 14h9m4 0h1v-9h-10m-4 0v16"}],["path",{"d":"M3 3l18 18"}]]);